/**
 * Fixed tab names for the two sites. Links between them target these names, so
 * the browser reuses one admin tab and one customer tab instead of opening a new
 * one per click. Where it cannot find the named tab (tabs the user opened
 * separately, or a Cross-Origin-Opener-Policy header), it opens a new tab.
 */
export const ADMIN_TAB_NAME = "penn-admin-console";
export const CUSTOMER_TAB_NAME = "penn-customer-site";

/** Name this tab so the other site's links can find it. Call once at boot. */
export function claimTabName(name: string): void {
  if (typeof window !== "undefined" && window.name !== name) window.name = name;
}
